// extracted by mini-css-extract-plugin
module.exports = {"content":"dd31006766--content--_Fyh8","content-mobile":"dd31006766--content-mobile--uGUI2"};